<template>
  <div class="table-container">
    <!-- 表格容器 -->
    <div class="table-wrapper" style="overflow-x: auto; -webkit-overflow-scrolling: touch;">
      <table class="copyable-table">
        <thead>
          <tr>
            <th>机构</th>
            <th v-if="!isMobile">结构</th>
            <th>2W</th>
            <th>1M</th>
            <th>2M</th>
            <th>3M</th>
            <th>6M</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in tableData" :key="index">
            <!-- 机构名 -->
            <td>{{ row['angry_name'] }}</td>
            <!-- 结构 -->
            <td v-if="!isMobile">{{ row['structure'] }}</td>
            <!-- 各期限数据 -->
            <td
              v-for="term in terms"
              :key="term"
              :class="{ 'red-text': isColumnMinValue(row[term], term) }"
            >
              {{ roundPercent(row[term]) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>


  </div>
</template>

<script>
import { copyTableToImage } from '@/utils/utils';

export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    now_str: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      terms: ['2W', '1M', '2M', '3M', '6M'],
      isMobile: window.innerWidth <= 768, // 判断是否为移动设备
      currentDate: (() => {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      })()
    };
  },
  computed: {
    columnMinValues() {
      const mins = {};
      this.terms.forEach(term => {
        const values = this.tableData
          .map(row => this.parseValue(row[term])) // 转换为数值
          .filter(v => !isNaN(v) && v !== 0); // 过滤掉 NaN 和 0

        mins[term] = values.length > 0 ? Math.min(...values) : null; // 只有非空时才取最小值
      });
      return mins;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    parseValue(val) {
      if (typeof val === 'string' && val.includes('%')) {
        return parseFloat(val.replace('%', '')) || 0;
      }
      return parseFloat(val) || 0;
    },
    isColumnMinValue(value, term) {
      const parsedValue = this.parseValue(value);
      return parsedValue !== 0 && parsedValue === this.columnMinValues[term];
    },
    roundPercent(value) {
      if (typeof value === 'string' && value.includes('%')) {
        const parsedValue = parseFloat(value.replace('%', '')) || 0;
        if (parsedValue < 1) {
          return (parsedValue * 100).toFixed(3) + '%';
        }
        return parsedValue.toFixed(2) + '%';
      }
      const numericValue = parseFloat(value) || 0;
      return (numericValue * 100).toFixed(2) + '%';
    },
    copyTableToImage() {
      const table = document.querySelector('.copyable-table');
      const firstRow = table.rows[1];
      const thirdCell = firstRow.cells[2];
      const cellContent = thirdCell.textContent;
      const fileName = `个股【${cellContent}】期权查询情况_${this.currentDate}.png`;
      copyTableToImage(table, fileName);
    },
    copyTableYhToImage() {
      const tempTable = document.createElement('table');
      tempTable.className = 'copyable-table';

      // 添加表头
      const thead = document.createElement('thead');
      const headerRow = document.createElement('tr');
      ['日期', '询价标的', '标的名称', '结构', '名义本金', '期限'].forEach(header => {
        const th = document.createElement('th');
        th.textContent = header;
        headerRow.appendChild(th);
      });
      thead.appendChild(headerRow);
      tempTable.appendChild(thead);

      // 添加表体
      const tbody = document.createElement('tbody');
      this.tableData.forEach(row => {
        const tr = document.createElement('tr');
        [row.date, row.stock_code, row.stock_name, row.structure, row.total_principal_label, row.term].forEach(cell => {
          const td = document.createElement('td');
          td.textContent = cell;
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      tempTable.appendChild(tbody);

      const firstRow = tempTable.rows[1];
      const thirdCell = firstRow.cells[2];
      const cellContent = thirdCell.textContent;
      const fileName = `个股【${cellContent}】期权查询情况_${this.currentDate}.png`;
      copyTableToImage(tempTable, fileName);
    },
    yh_price() {
      const table = document.querySelector('.copyable-table');
      const firstRow = table.rows[1];
      const stock_code = firstRow.cells[1].textContent;
      const stock_name = firstRow.cells[2].textContent;

      const text = ` 标的：${stock_name} ${stock_code}
        期权结构：100%
        名义本金：100W
        期权费率：100%
        时间期限：1M`;

      navigator.clipboard.writeText(text)
        .then(() => alert('内容已成功复制到剪贴板'))
        .catch(err => {
          console.error('无法复制内容到剪贴板', err);
          alert('无法复制内容到剪贴板');
        });
    }
  }
};
</script>

<style scoped>
/* 页面容器 */
.table-container {
  padding: 1rem;
  max-width: 100%;
  box-sizing: border-box;
}

/* 表格容器 */
.table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 15px; /* 新增表格底部间距 */
}

.copyable-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
  line-height: 1.5;
}

.copyable-table th,
.copyable-table td {
  padding: 0.5rem;
  text-align: center;
  border: 1px solid #ddd;
}

.copyable-table th {
  background-color: #f8f9fa;
    min-width: 3rem;
}

.red-text {
  color: #ff0000; /* 最小值标红 */
  font-weight: bold;
}

.highlight {
  background-color: #ffeb3b;
}

/* 按钮样式 */
.button {
  font-size: 0.9rem;
  padding: 0.5rem;
  margin: 0.5rem 0;
  border-radius: 0.25rem;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}

.button:hover {
  background-color: #0056b3;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .table-container {
    padding: 0.5rem;
  }

  .copyable-table {
    font-size: 0.8rem;
  }

  .button {
    font-size: 0.8rem;
    padding: 0.5rem;
    width: 100%;
  }
}
</style>
